import {
  Gauge, MapPin, ClockCounterClockwise, Warning, Bell, Truck, Users,
  Buildings, Cpu, Heartbeat, Terminal, DownloadSimple, SimCard, Wrench,
  Certificate, Broadcast, Polygon, ArrowsClockwise, FileText, UsersThree,
  ShieldCheck, ListChecks, PlugsConnected, Path, EnvelopeSimple, SlidersHorizontal, MapTrifold, UserCircle, Rocket, ClipboardText, ChartBar, Gear,
} from "@phosphor-icons/react";

// roles empty => visible to all authenticated users. super_admin sees everything.
export const NAV = [
  { section: "Operations", items: [
    { label: "Dashboard", path: "/", icon: Gauge },
    { label: "Live Tracking", path: "/tracking", icon: MapPin },
    { label: "History", path: "/history", icon: ClockCounterClockwise },
    { label: "Emergency", path: "/emergency", icon: Warning, roles: ["super_admin", "control_room", "state_admin", "support"] },
    { label: "Alerts", path: "/alerts", icon: Bell },
    { label: "Alert Rules", path: "/alert-rules", icon: SlidersHorizontal, roles: ["super_admin", "oem_admin", "fleet_admin"] },
  ]},
  { section: "Fleet", items: [
    { label: "Vehicles", path: "/vehicles", icon: Truck },
    { label: "Drivers", path: "/drivers", icon: Users },
    { label: "Geofences", path: "/geofences", icon: Polygon },
    { label: "Routes", path: "/routes", icon: Path },
    { label: "POI & Landmarks", path: "/pois", icon: MapTrifold },
    { label: "Vehicle Groups", path: "/groups", icon: UsersThree, roles: ["super_admin", "oem_admin", "state_admin", "distributor", "dealer", "fleet_admin"] },
    { label: "Graphics", path: "/graphics", icon: ChartBar },
    { label: "Maintenance", path: "/maintenance", icon: Wrench, roles: ["super_admin", "oem_admin", "state_admin", "distributor", "dealer", "fleet_admin"] },
  ]},
  { section: "Devices", items: [
    { label: "Add Device", path: "/add-device", icon: PlugsConnected, roles: ["super_admin", "oem_admin", "state_admin", "distributor", "dealer", "fleet_admin"] },
    { label: "Raw Packets", path: "/raw-data", icon: ListChecks, roles: ["super_admin", "oem_admin", "support"] },
    { label: "Activation Log", path: "/activation-log", icon: ClipboardText, roles: ["super_admin", "oem_admin", "state_admin", "distributor", "dealer", "fleet_admin", "support"] },
    { label: "Deployment Guide", path: "/deployment", icon: Rocket, roles: ["super_admin", "oem_admin"] },
    { label: "Settings & Rules", path: "/settings", icon: Gear, roles: ["super_admin", "oem_admin"] },
    { label: "Inventory", path: "/devices", icon: Cpu },
    { label: "Device Health", path: "/device-health", icon: Heartbeat },
    { label: "Device Gateway", path: "/gateway", icon: PlugsConnected, roles: ["super_admin", "oem_admin", "support"] },
    { label: "Live Monitor", path: "/live-monitor", icon: Broadcast, roles: ["super_admin", "oem_admin", "support"] },
    { label: "Commands", path: "/commands", icon: Terminal },
    { label: "Firmware", path: "/firmware", icon: DownloadSimple },
  ]},
  { section: "AIS-140", items: [
    { label: "Installations", path: "/installations", icon: Wrench },
    { label: "Certificates", path: "/certificates", icon: Certificate },
    { label: "Government Push", path: "/gov-push", icon: Broadcast, roles: ["super_admin", "state_admin", "oem_admin"] },
  ]},
  { section: "Business", items: [
    { label: "Customers", path: "/customers", icon: UserCircle, roles: ["super_admin", "oem_admin", "state_admin", "distributor", "dealer", "fleet_admin"] },
    { label: "SIM Management", path: "/sims", icon: SimCard },
    { label: "Dealers", path: "/dealers", icon: Buildings },
    { label: "Renewals", path: "/renewals", icon: ArrowsClockwise },
    { label: "Reports", path: "/reports", icon: FileText },
    { label: "Report Schedule", path: "/report-schedule", icon: EnvelopeSimple, roles: ["super_admin", "oem_admin"] },
  ]},
  { section: "Admin", items: [
    { label: "Users & Roles", path: "/users", icon: UsersThree, roles: ["super_admin", "oem_admin"] },
    { label: "Audit Log", path: "/audit", icon: ShieldCheck, roles: ["super_admin", "oem_admin", "support"] },
  ]},
];

export function visibleFor(role) {
  return NAV.map((s) => ({
    ...s,
    items: s.items.filter((it) => !it.roles || role === "super_admin" || it.roles.includes(role)),
  })).filter((s) => s.items.length > 0);
}
